import { ViewportScroller } from '@angular/common';
import { Component, ElementRef, HostListener, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ContatoService } from 'src/app/service/contato.service';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import Tools from 'src/app/util/Tools';

@Component({
  selector: 'app-politica-vendas',
  templateUrl: './politica-vendas.component.html',
  styleUrls: ['./politica-vendas.component.scss']
})
export class PoliticaVendasComponent implements OnInit {
  public formContato!: FormGroup;
  showScrollButton = false;

  public year = new Date().getFullYear();

  // Referênciando variavel grecaptcha
  @ViewChild('divRecaptcha')
  divRecaptcha!: ElementRef<HTMLDivElement>;
  // *
  // * Quando adicionamos o script do reCAPTCHA no
  // * index.html, o script cria uma variável de
  // * escopo global chamada "grecaptcha".
  // * Então para pegar sua referência podemos
  // * acessá-la através do "window"
  // *
  get grecaptcha(): any {
    const w = window as any;
    return w['grecaptcha'];
  }

  constructor(
    private el: ElementRef,
    private contato: ContatoService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private viewportScroller: ViewportScroller,
    private ngZone: NgZone,
  ) {
    this.renderizarReCaptcha();
  }

  ngOnInit(): void {
    this.initForm();
  }

  public renderizarReCaptcha() {
    // *
    // * Para evitar que change detection seja disparado
    // * cada vez que o setTimeout for executado,
    // * executamos essa recorrência fora da zona
    // * do Angular, por isso o usamos o runOutsideAngular
    // *
    // * Para saber mais sobre change detection:
    // * https://consolelog.com.br/como-funciona-change-detection-angular/
    // * 
    this.ngZone.runOutsideAngular(() => {
      // *
      // * Se o "grecaptcha" ainda não foi carregado ou
      // * o elemento <div> onde o reCAPTCHA será
      // * renderizado ainda não foi construído,
      // * aguardamos algum tempo e executamos novamente
      // * este método:
      // *
      if (!this.grecaptcha || !this.divRecaptcha) {
        setTimeout(() => {
          this.renderizarReCaptcha();
        }, 500);

        return;
      }

      // * Se chegou aqui é porque o recaptcha já está
      // * carregado. Então solicitamos sua renderização
      // * na tela.
      const idElemento =
        this.divRecaptcha.nativeElement.getAttribute('id');

      this.grecaptcha.render(idElemento, {
        sitekey: '6Lca_nkpAAAAANZCS80-ZF5jL96XAjpwuJ2Tjvi9',
        callback: (response: string) => {
          // * Este método é chamado quando o usuário
          // * resolver o desafio do CAPTCHA
          this.ngZone.run(() => {
            this.formContato.get('recaptcha')?.setValue(response);
          });
        },
      });
    });
  }

  scrollToFormulario() {
    const formularioElement = this.el.nativeElement.querySelector('#formulario');

    if (formularioElement) {
      formularioElement.scrollIntoView({ behavior: 'smooth' });
    }
  }


  public enviaFormularioContato() {
    const dados = {
      ...this.formContato.value,
      whatsapp: Tools.formatarTelefone(this.formContato.get('whatsapp')?.value)
    }

    if (this.formContato.valid) {
      this.contato.contatoUsuario(dados).subscribe(res => {
        if (res.status) {
          this.dialog.open(DialogComponent, { data: res.mensagem })
          this.formContato.reset();
        } else {
          this.dialog.open(DialogComponent, { data: res.mensagem })
        }
      })
    }
  }

  private initForm() {
    this.formContato = this.formBuilder.group({
      nome: ['', Validators.required],
      email: ['', Validators.required],
      whatsapp: ['', Validators.required],
      escola: ['', Validators.required],
      mensagem: [''],
      recaptcha: ['', Validators.required]
    }
    )
  }

  @HostListener('window:scroll', [])

  onWindowScroll() {
    const sectionToReach = document.getElementById('banner');
    if (!sectionToReach) {
      return;
    }

    const scrollPosition = this.viewportScroller.getScrollPosition()[1];
    const sectionPosition = sectionToReach.offsetTop;

    this.showScrollButton = scrollPosition > sectionPosition;
  }

  scrollToTop() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
